import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getTradePlaces, saveBatchTradePlaces } from '../../api/tradePlaces';
import type { TradePlace } from '../../types/TradePlace';
import { t } from '../../i18n/t';

const columnDefs: ColDef<TradePlace>[] = [
  {
    field: 'tradePlaceId',
    headerName: t('tradePlaces.columns.tradePlaceId'),
    width: 140,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<TradePlace>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  {
    field: 'tradePlaceName',
    headerName: t('tradePlaces.columns.tradePlaceName'),
    flex: 1,
    editable: true,
  },
];

const newRowDefaults = (): Partial<TradePlace> => ({
  tradePlaceId: 0,
  tradePlaceName: '',
});

export function TradePlacesPage() {
  return (
    <LopCrudPage<TradePlace>
      resourceCode="tradePlaces"
      titleKey="tradePlaces.pageTitle"
      idField="tradePlaceId"
      getRows={getTradePlaces}
      saveBatch={(added, modified, deletedIds) =>
        saveBatchTradePlaces(added, modified, deletedIds as number[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
